export default class TransferenciaDefinitiva {

  constructor(data = {}) {
    this.motivo = data.motivo;
    this.cenario = data.cenario || 1;
    this.funcionarioDe = data.funcionarioDe;
    this.funcionarioPara = data.funcionarioPara;
    this.usuarios = data.usuarios || [];
    this.inativarUsuario = data.inativarUsuario || false;
    this.transferenciaCarteira = data.transferenciaCarteira || 1;
    this.transferenciaResponsavelFaturamento = data.transferenciaResponsavelFaturamento || 1;
    this.carteiras = data.carteiras || [];
    this.clientes = data.clientes || [];
    this.orcamentos = data.orcamentos || [];
    this.aceito = data.aceito || false;
  }
}



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/transferencia-posse/definitiva/TransferenciaDefinitiva.js